import React, { useEffect, useState } from "react";
import "./ConfirmLogoutModal.css";
import { reactIcons } from "../../icons/reactIcons";

interface ConfirmLogoutModalProps {
  open: boolean;
  onClose: () => void;
  onLogout: () => Promise<void>;
}

const ConfirmLogoutModal: React.FC<ConfirmLogoutModalProps> = ({
  open,
  onClose,
  onLogout,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => document.body.classList.remove("modal-open");
  }, [open]);

  if (!open) return null;

  const handleLogout = async () => {
    setLoading(true);
    await onLogout();
    setLoading(false);
  };

  return (
    <div className="logout-modal-overlay">
      <div className="logout-modal-container">
        <div className="logout-modal-header">
          <reactIcons.InfoIcon fontSize={24} />
          <h3>Log Out</h3>
        </div>

        <p className="logout-text">Are you sure you want to Log Out?</p>

        <div className="logout-modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>

          <button
            className="logout-btn"
            onClick={handleLogout}
            disabled={loading}
          >
            {loading ? <div className="spinner"></div> : "Yes, Log Out"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmLogoutModal;
